interface PromptState {
	prompt: string
}

const selectPrompt = (state: PromptState) => state.prompt

export default selectPrompt
